export default __webpack_public_path__ + "assets/profeature-card.e2761be641d4572fb9d6c52d9078ceef.jpg";